import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import Error403 from '../../../pages/Error403';
import Error500 from '../../../pages/Error500';
import AdminAuthContainer from '../AdminAuthContainer';
import AdminSsoContainer from '../AdminSsoContainer';
import SsoList from '../components/AdminSso/SsoList';

const StyledPanelContainer = styled.div``;

const Sso = () => {
    const { ssoFetchStatus, ssoFetchError } = useContainer(AdminSsoContainer);
    const { isAdmin, isLoading } = useContainer(AdminAuthContainer);

    const renderSso = () => {
        switch (ssoFetchStatus) {
            case 'INITIAL':
            case 'LOADING':
                return <CircularProgress />;
            case 'SUCCESS':
                return <SsoList />;
            case 'ERROR':
            default:
                return (
                    <Error500
                        errorMessage={ssoFetchError?.response?.statusText}
                        errorData={ssoFetchError?.response?.data?.error}
                    />
                );
        }
    };

    if (!isAdmin && !isLoading) {
        return <Error403 />;
    }

    return <StyledPanelContainer>{renderSso()}</StyledPanelContainer>;
};

export default Sso;
